module.exports = __webpack_public_path__ + "static/img/thu truong B.a539399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thu truong B.jpg
// module id = p11t
// module chunks = 1